import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, Row, Form, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import MainProjectForm from './MainProjectForm'
import SubProjectForm from './SubProjectForm'
import ButtonPanelWidget from '../ButtonPanelWidget'
import moment from 'moment'
import {
  getProgressiveFormDate,
  saveProgressiveSubProjec,
} from '../../redux/actions/progressiveReport'
import { DATE_FORMAT } from '../../constants/date'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'

export default function ProgressiveSubProjectWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, handleCancelProgress } = props
  const history = useHistory()

  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [mainSchema, setMainSchema] = useState(props.schema.mainProject)
  const [subSchema, setSubSchema] = useState(props.schema.subProjects)
  const [loading, setloading] = useState(false)
  const [errorMsg, setErrorMsg] = useState()
  const [isDisabled, setIsDisabled] = useState(true)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (formSchema?.buttonText) {
      formSchema.buttonText.cancelButtonName = 'ยกเลิก'
    }
  }, [props.schema])

  useEffect(() => {
    if (props?.schema?.subProjects?.values?.length > 0) {
      setIsDisabled(false)
    }
  }, [props.schema.subProjects])

  const onSubmit = (data) => {
    console.log('data', data)

    let newArray = []
    data.subProject.map((sub, index) => {
      const { isSelectSubProject } = sub

      if (isSelectSubProject) {
        newArray.push(data.subProject[index])
      }
    })

    const request = {
      progressDate: moment(data.progressDate).format(DATE_FORMAT),
      remark: data.remark,
      subProject: newArray,
    }

    handleSaveProgressiveSubProjec(projectId, request)
  }

  const handleSaveProgressiveSubProjec = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      response = await saveProgressiveSubProjec(id, request)

      if (response) {
        setErrorMsg({ type: 'success', description: 'บันทึกสำเร็จ' })
      } else {
        setErrorMsg({ type: 'error', description: 'บันทึกไม่สำเร็จ' })
      }
      setTimeout(() => setErrorMsg(null), 3000)
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleGetSchema = async (projectId, date) => {
    setIsLoading(true)
    startLoading()
    try {
      setSubSchema()
      const response = await getProgressiveFormDate(projectId, date)
      console.log('response ', response)
      if (response) {
        // setMainSchema(response.forms.mainProject)
        // formSchema.subProjects = response.forms.subProjectList.subProjects
        setSubSchema(response.forms.subProjectList.subProjects)
        setIsDisabled()
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleChangeReportDate = (date) => {
    setSubSchema({})

    if (date) {
      console.log(subSchema)
      handleGetSchema(projectId, moment(date).format(DATE_FORMAT))
    }
  }

  const handleOnChangeSelectSubproject = (index) => {
    const valueChecked = getValues()

    subSchema.values[index].isSelectSubProjectValue =
      valueChecked.subProject[index].isSelectSubProject

    const setSchema = {
      ...subSchema,
    }

    setSubSchema(setSchema)
  }

  console.log('formSchemaformSchemaformSchemaformSchema ', formSchema)

  return (
    <>
      <Panel shaded header={formSchema.header} bordered collapsible defaultExpanded>
        <Form>
          {mainSchema && (
            <MainProjectForm
              schema={mainSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              onChangeReportDate={handleChangeReportDate}
            />
          )}
          <br />

          {errorMsg && (
            <Message
              showIcon
              type={errorMsg.type}
              description={errorMsg.description}
              style={{ marginBottom: 20 }}
            />
          )}

          {subSchema && (
            <SubProjectForm
              schema={subSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              clearErrors={clearErrors}
              setValue={setValue}
              onSelectSubproject={handleOnChangeSelectSubproject}
            />
          )}
        </Form>

        <Row style={{ textAlign: 'center' }}>
          <hr />
          <ButtonPanelWidget
            isEdit={true}
            isError={isError}
            buttonText={formSchema.buttonText}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              console.log('onCancel')
              history.push({
                pathname: pathname.subProject.subProjectDashboard,
              })
            }}
            isDisabled={isDisabled}
            // onCancel={() => {
            //   history.push({
            //     pathname: `/dashboard?9`,
            //   })
            // }}
          />
        </Row>
      </Panel>
    </>
  )
}
